import {queryOptions} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {AssistantDependencies} from '../dependencies';
import type {ConversationId} from '../domain/conversation-id.value-object';
import {keys} from './keys';

export type GetConversationQueryDependencies = Pick<AssistantDependencies, 'controllers'>;

export const getConversationQuery = (
  {controllers}: GetConversationQueryDependencies,
  conversationId: ConversationId,
) =>
  queryOptions({
    queryKey: keys.detail(conversationId),
    queryFn: () => controllers.assistantController.getById(conversationId).then(unwrap),
  });
